export default (name: string, ...args: any[]) => {
  if (window.plausible) {
    window.plausible(name, args);
  }
};
